import LocalizationService from "services/localizationService";
import { bound } from "@frui.ts/helpers";
import ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import { interfaces } from "inversify";
import SelectPaymentMethodViewModel from "viewModels/common/payment/selectPaymentMethodViewModel";
import { ConductorAllChildrenActive } from "@frui.ts/screens";
import ChargeOrder from "models/chargeOrder";

export default class PaymentViewModel extends ConductorAllChildrenActive<ScreenBase> {
  constructor(
    public chargeOrder: ChargeOrder,
    public localizationService: LocalizationService,
    private selectPaymentMethodViewModelFactory: ReturnType<typeof SelectPaymentMethodViewModel.Factory>
  ) {
    super();

    this.children.push(this.selectPaymentMethodViewModelFactory(this.chargeOrder));
  }

  @bound
  translateGeneral(code: string) {
    return this.localizationService.translateGeneral(`eshop.order.summary.${code}`);
  }

  static Factory({ container }: interfaces.Context) {
    return (chargeOrder: ChargeOrder) => {
      return new PaymentViewModel(
        chargeOrder,
        container.get(LocalizationService),
        container.get(SelectPaymentMethodViewModel.Factory)
      );
    };
  }
}
